import React, { useEffect, useRef, useState } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import bannerCaravanasSenasaDesk from '../../assets/bannerCaravanasSenasaDesk.jpg'
import bannerOctubreDesk from '../../assets/bannerOctubreDesk.gif'
import bannerOctubreMobile from '../../assets/bannerOctubreMobile.gif'
import bannerCaravanasSenasaMobile from '../../assets/bannerCaravanasSenasaMobile.jpg'
import BannerComederos from '../../assets/bannerComederos.png'
import BannerComederosMobile from '../../assets/bannerComederosMobile.png'
import bannerBarraPaintstikMobile from '../../assets/bannerBarraPaintstikMobile.png'
import bannerBarraPaintstikDesk from '../../assets/bannerBarraPaintstikDesk.png'
import bannerVacunacion from '../../assets/bannerVacunacion.png'
import BannerAliflexMobile from '../../assets/offersBannerMobile2.png'
import { useMediaQuery, Box, Skeleton } from '@mui/material'
import { useStyles } from './Home.styles'
import ProductsSection from '../../components/ProductsSection'
import CategoriesSection from '../../components/CategoriesSection/index'
import FAQSection from '../../components/FAQSection/index'
import SearchBox from '../../components/SearchBox'
import { useDispatch, useSelector } from 'react-redux'
import CarrouselControl from 'components/CarrouselControl'
import getBestsellers from './services/getBestsellers'
import { clearAllFilters, searchQuery } from 'stores/searchStore/actionsSearch'
import getFinderResults from './services/getFinderResults'
import { Helmet } from 'react-helmet'
import { getUserPromotionsAndOffers, updateUserInfo } from 'stores/userStore/actionsUser'
import NewClientPopup2 from 'components/NewClientsPopup/newClientsPopup2'
import { buildBreadcumbs } from 'utils/filters'
import NewsSection from 'components/NewsSection/index'
import { useNavigate } from 'react-router-dom'
import getProductsSections from './services/getProductsSections'
// 
const images = [
  { _id: '3', name: 'Texto para imagen 3', src: bannerOctubreDesk, redirectTo: '/catalogo/promociones' },
  { _id: '3', name: 'Texto para imagen 3', src: bannerCaravanasSenasaDesk, redirectTo: '/catalogo/identificacion-animal/caravanas-oficiales-visuales' },
  { _id: '4', name: 'Texto para imagen 4', src: bannerBarraPaintstikDesk, redirectTo: '/catalogo/identificacion-animal/accesorios-identificacion-animal/pinturas' },
  { _id: '5', name: 'Texto para imagen 5', src: bannerVacunacion },
  { _id: '6', name: 'Texto para imagen 6', src: BannerComederos },
]

const mobileImagesBanner = [
  { _id: '1', name: 'Text para imagen 2', src: bannerOctubreMobile, redirectTo: '/catalogo/promociones' },
  { _id: '3', name: 'Texto para imagen 3', src: bannerCaravanasSenasaMobile, redirectTo: '/catalogo/identificacion-animal/caravanas-oficiales-visuales' },
  { _id: '2', name: 'Text para imagen 2', src: BannerAliflexMobile },
  { _id: '3', name: 'Text para imagen 2', src: bannerBarraPaintstikMobile, redirectTo: '/catalogo/identificacion-animal/accesorios-identificacion-animal/pinturas' },
  { _id: '4', name: 'Text para imagen 2', src: BannerComederosMobile },
]


let popupAlreadyShowed = false

const Home = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const desktop = useMediaQuery((theme) => theme.breakpoints.up('md'), { noSsr: true })
  const itemsDesktop = 12
  const [, setCarrouselCurrent] = useState()
  const imageRef = useRef()

  const { userInfo, signedIn } = useSelector(({ userAuth }) => userAuth)
  const { formatedFilters } = useSelector(({ searchResults }) => searchResults)
  const desktopBanners = useSelector(({ app }) => app.banners?.home?.desk)
  const mobileBanners = useSelector(({ app }) => app.banners?.home?.mobile)
  const initFinished = useSelector(({ app }) => app.initFinished)
  const [productsSections, setProductsSections] = useState([])

  const [caravanasOficiales, setCaravanasOficiales] = useState([])
  const [bestsellers, setBestsellers] = useState([])
  const [newPopupOpen, setNewPopupOpen] = useState(false)
  

  useEffect(() => {
    if(!userInfo?.codigoUsuario) return;

    // getFinderResults(
    //   { type: 'subLinea', value: 91 },
    //   itemsDesktop,
    //   userInfo?.codigoUsuario,
    //   1
    // ).then((res) => setCaravanasOficiales(res.products))

    // // getFinderResults(
    // //   { type: 'tipo', value: 'product_manejo' },
    // //   itemsDesktop,
    // //   userInfo?.codigoUsuario,
    // //   1
    // // ).then((res) => setRecomendados(res.products))

    // getBestsellers(userInfo?.codigoUsuario).then((res) => {
    //   setBestsellers(res.map((item) => item.producto))
    // })

    getProductsSections(userInfo?.codigoUsuario)
      .then(setProductsSections)

  }, [userInfo?.codigoUsuario])

  useEffect(() => {
    if (!userInfo.user) return;
    dispatch(getUserPromotionsAndOffers(userInfo.user))
    dispatch(updateUserInfo(userInfo.user))
  }, [userInfo.user])

  useEffect(() => {
    dispatch(clearAllFilters())
    if(!signedIn && !popupAlreadyShowed){
      popupAlreadyShowed = true
      return setNewPopupOpen(true)
    }
  }, [])

  const handleCarrouselItemChange = (index) => {
    const carrouselItemsArray = desktop ? images : mobileImagesBanner
    if(carrouselItemsArray[index].redirectTo){
      imageRef.current.parentNode.parentNode.style.cursor = 'pointer'
    } else {
      imageRef.current.parentNode.parentNode.style.cursor = 'auto'
    }
    setCarrouselCurrent(index)
  }

  return (
    <>
      <Helmet>
        <title>VILLANUEVA</title>
        <meta
          name='description'
          content='Empresa distribuidora de insumos agropecuarios y ganaderos. Caravanas Oficiales. Sitio oficial VILLANUEVA. ¡Encontrá todos los productos de identificación animal, salud animal, rural, y muchos más!'
        />
        <meta
          name='keywords'
          content='villanueva,villa nueva,caravanas oficiales,villanuevafull,villa nueva s.a,villa nueva sa,insumos agropecuarios,agropecuario,ganadería,ganadero'
        />
      </Helmet>
      <NewClientPopup2 
        isOpen={newPopupOpen} 
        onClose={() => {
          // localStorage.setItem('newClientMessageShowed', 'true')
          setNewPopupOpen(false)
        }}
      />
      <Box className={classes.container}>
        {!desktop && (
          <Box className={classes.searchGrid}>
            <SearchBox />
          </Box>
        )}
        {initFinished ? (
          <Carousel
            className={classes.carousel}
            showArrows
            autoPlay
            onClickItem={(itemIndex) => 
              navigate((desktop ? desktopBanners : mobileBanners)[itemIndex].redirectTo || '/')
            }
            infiniteLoop
            onChange={handleCarrouselItemChange}
            interval={5000}
            showThumbs={false}
            renderArrowNext={(onClick, nextItem) => {
              if (desktop) {
                return (
                  <CarrouselControl
                    onClick={onClick}
                    nextItem={nextItem}
                    direction='right'
                  />
                )
              }
              return <></>
            }}
            renderArrowPrev={(onClick, prevItem) => {
              if (desktop) {
                return (
                  <CarrouselControl
                    onClick={onClick}
                    previousItem={prevItem}
                    direction='left'
                  />
                )
              }
              return <></>
            }}
          >
            {(desktop ? desktopBanners : mobileBanners).map((image, index) => (
              <img
                className={classes.image}
                src={`${process.env.REACT_APP_URL_BACKEND_REMOTO}/files/${image.file.ruta}`}
                alt={image.label}
                key={index}
                ref={image.redirectTo ? imageRef : null}
                id={image.redirectTo ? 'carrouselImgRedirect' : 'carrousel'}
              />
            ))}
          </Carousel>
        ): 
          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={"75vh"} />
        }
        <Box className={classes.innerContainer}>
          <CategoriesSection />
          {productsSections.length > 0 && (
            <Box className={classes.mainGrid}>
              {productsSections.map((section, index) => (
                <ProductsSection
                  key={section.id}
                  titleSection={section.label}
                  data={section.products}
                  redirectTo={section.redirectTo}
                  carouselIndex={index}
                />
              ))}
            </Box>
          )}
        </Box>
        {/* <Box className={classes.fullImgContainer}>
          <img className={classes.fullImg} src={BannerAnimated2} alt='Home' />
        </Box> */}
        <Box className={classes.innerContainer}>
          <Box className={classes.mainGrid}>
            {/* <ProductsSection
              titleSection='Recomendados para vos'
              toURL=''
              buttonLabel='Recomendados'
              showButton={true}
              data={recomendados}
              carouselIndex={3}
            /> */}
            {process.env.REACT_APP_ENVIRONMENT === 'development' && (
              <NewsSection />
            )}
          </Box>
        </Box> 
        <FAQSection />
      </Box>
    </>
  )
}

export default Home
